// extracted by mini-css-extract-plugin
export default {"modal":"CreateNewPosition_modal__FWKRn"};